import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Unstable_Grid2 as Grid } from '@mui/material';
import ProgressChart from 'components/progress/physical/ProgressChart';
import ProgressMeasurementsDonut from 'components/progress/physical/ProgressMeasurementsDonut';

const dateOf = (e) => e?.taken_at || (e?.created_at || '').slice(0, 10) || '';

/**
 * Zona de gráficas del progreso físico: Evolución (línea) + donut "Resumen última entrada".
 * La línea aparece con ≥2 entradas; el donut con la entrada más reciente.
 */
function ProgressCharts({ entries }) {
  const latest = useMemo(
    () => [...entries].sort((a, b) => (dateOf(a) < dateOf(b) ? 1 : -1))[0],
    [entries]
  );
  const hasLine = entries.length >= 2;

  if (!latest) return null;

  return (
    <Grid container spacing={2.5} sx={{ mb: 2.5 }}>
      {hasLine && <Grid xs={12} md={7}><ProgressChart entries={entries} /></Grid>}
      <Grid xs={12} md={hasLine ? 5 : 12}><ProgressMeasurementsDonut entry={latest} /></Grid>
    </Grid>
  );
}

ProgressCharts.propTypes = { entries: PropTypes.arrayOf(PropTypes.object).isRequired };

export default ProgressCharts;
